module.exports = __webpack_public_path__ + "img/icon3.99f63ff4.png";